import React from "react";
import { Info } from "lucide-react";
import { cn } from "./formStyles";

const InfoTooltip = ({
  text,
  iconSize = 15,
  className = "",
  align = "center",
}) => (
  <span
    className={cn(
      "relative inline-flex group cursor-help align-middle",
      className
    )}
  >
    <Info size={iconSize} className="text-gray-400" />
    <span
      role="tooltip"
      className={cn(
        "invisible absolute bottom-full z-20 mb-2 w-64 rounded-lg bg-blue-600 px-3 py-2 text-xs font-normal leading-snug text-white opacity-0 shadow-lg transition-opacity duration-150 group-hover:visible group-hover:opacity-100",
        align === "start" && "left-0",
        align === "end" && "right-0",
        align === "center" && "left-1/2 -translate-x-1/2"
      )}
    >
      {text}
      <span
        className={cn(
          "absolute top-full border-4 border-transparent border-t-blue-600",
          align === "start" && "left-2",
          align === "end" && "right-2",
          align === "center" && "left-1/2 -translate-x-1/2"
        )}
      />
    </span>
  </span>
);

export default InfoTooltip;
